export enum QUESTION_TYPE {
  MCQ = 1,
  DESCRIPTIVE = 2,
  PICTORIAL = 3,
  FILL_IN_THE_BLANK = 4,
  BOW_TIE = 5,
  MATRIX = 6,
  FILL_IN_THE_BLANK_TEXTUAL = 7,
  FILL_IN_THE_BLANK_FROM_LIST = 8,
  FINDINGS = 9,
  HIGHLIGHTED = 10,
  CASE_STUDY = 11,
  // WHITE_BOARD = 7,
}
